

window.addEventListener('DOMContentLoaded', () => {
     window.egResizeImageHelper = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master|1600x)+\./g, '.')
    	.replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
          if (crop.length) {
              // eslint-disable-next-line no-param-reassign
              crop = `_crop_${crop}`
          }
        return `_${size}${crop}${match}`
    })
  
    document.querySelectorAll('.header .link').forEach(element => {
      if (element.textContent.includes('|')) {
        const title = element.textContent.split('|')[0]
        let image = element.textContent.split('|')[1]

        image = window.egResizeImageHelper(image.replace(/ /g, ''), '360x')

        element.innerHTML = `
            <img class="img-fluid" src="${image}" alt="" width="360" height="" loading="lazy" style="max-width: 100%; height: auto;">
            <h5 style="margin-top: .5rem; margin-bottom: 0;">${title}</h5>
        `

        element.style.textAlign = 'center'
        element.style.display = 'block'
      }
  })
})
